import http from '../http'

export default {
  listSearchableEntityTypes() {
    return http.get('/search/admin/v1/types')
  },

  freeTextSearch(query) {
    return http.get('/search/v1/freetext', {
      params: {
        q: query
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/service/apis/EntitySearch.js